<template>
  <div>
    <v-layout wrap>
      <v-flex xs9>{{ $t('Set time') }}</v-flex>
      <v-flex xs3 class="text-xs-right">
        <div
          class="btn-floating btn-outline-red"
          style="margin-left:5px;margin-bottom: 5px;"
          v-if="!isEdit"
          @click="isEdit = true"
        >
          <i class="fa fa-pencil-alt middle"></i>
        </div>
      </v-flex>
    </v-layout>
    <v-card class="mt-2">
      <div class="pa-2 hidden-xs-only">
        <v-layout wrap>
          <v-flex xs4 class="text-xs-center strong">{{ $t('Date_1') }}</v-flex>
          <v-flex xs4 class="text-xs-center strong">{{ $t('Open at') }}</v-flex>
          <v-flex xs4 class="text-xs-center strong">{{ $t('Close at') }}</v-flex>
        </v-layout>
      </div>
      <v-divider></v-divider>
      <template v-for="(time, key) in timetable">
        <open-time-bot-item
          :key="key"
          v-model="timetable[key]"
          :name="key"
          :isEdit="isEdit"
        ></open-time-bot-item>
      </template>
    </v-card>
    <div class="text-xs-center mt-4" v-if="isEdit">
      <v-btn color="grey" outline @click="onCancelTimeTable">{{ $t('cancel') }}</v-btn>
      <v-btn depressed color="primary" @click="onSaveTimeTable">{{ $t('Save') }}</v-btn>
    </div>
  </div>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
import OpenTimeBotItem from './OpenTimeBotItem'
export default {
  data() {
    return {
      isEdit: false,
      timetable: {
        Monday: { status: true, openat: null, closeat: null },
        Tuesday: { status: true, openat: null, closeat: null },
        Wednesday: { status: true, openat: null, closeat: null },
        Thursday: { status: true, openat: null, closeat: null },
        Friday: { status: true, openat: null, closeat: null },
        Saturday: { status: true, openat: null, closeat: null },
        Sunday: { status: true, openat: null, closeat: null }
      }
    }
  },
  components: {
    OpenTimeBotItem
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    })
  },
  mounted() {
    this.getTimeToUseBot()
  },
  methods: {
    getTimeToUseBot: function() {
      var vm = this
      return new Promise((resolve, reject) => {
        api.getTimeToUseBot({ pageid: this.selectedBot.pageid }, function(error, response) {
          if (error) {
            reject(error)
          }
          if (response.data) {
            if (response.data.timetousebot) {
              if (response.data.timetousebot) {
                vm.timetable = JSON.parse(response.data.timetousebot)
              } else {
                vm.timetable = {
                  Monday: { status: true, openat: null, closeat: null },
                  Tuesday: { status: true, openat: null, closeat: null },
                  Wednesday: { status: true, openat: null, closeat: null },
                  Thursday: { status: true, openat: null, closeat: null },
                  Friday: { status: true, openat: null, closeat: null },
                  Saturday: { status: true, openat: null, closeat: null },
                  Sunday: { status: true, openat: null, closeat: null }
                }
              }

              vm.cached_timetable = JSON.stringify(vm.timetable)
            }
            vm.cached_timetable = JSON.stringify(vm.timetable)
          }
          resolve()
        })
      })
    },
    onCancelTimeTable: function() {
      var vm = this
      vm.timetable = JSON.parse(vm.cached_timetable)
      vm.isEdit = false
    },
    onSaveTimeTable: function() {
      var vm = this
      return new Promise((resolve, reject) => {
        vm.$validator.validateAll().then(result => {
          if (!result) {
            // do stuff if not valid.
            vm.goToErrorInput()
            reject()
            return false
          }
          var data = {
            timetousebot: JSON.stringify(vm.timetable),
            pageid: this.selectedBot.pageid
          }
          api.saveTimeToUseBot(data, function(error, response) {
            if (error) {
              reject(error)
            }
            vm.cached_timetable = JSON.stringify(vm.timetable)
            vm.isEdit = false
            resolve()
          })
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/billing/ManageOpenTimeBot.vue